module.exports = __webpack_public_path__ + "img/monocycle-none-left.c6573303.jpg";